import { OriginDestinationOption } from "./OTAAirScheduleResponse";

export class Confirmation {
    flightOption: string;
    crewName: string;
    outbound: OriginDestinationOption;
    inbound?: OriginDestinationOption;

    isRoundTrip() {
        return this.flightOption === 'ROUND_TRIP';
    }
}